import axios from 'axios';
import server_config from '../../ServerConfiguration';

const node_server_address = server_config["node_server_address"];

export const fetchReleaseNotesAPI = async () => {
    let response = { 'success': false };
    response = await axios({
        method: 'POST',
        //url: server_address + ':' + ports["master_server"] + '/',
        url: node_server_address,
        timeout: 5000,
        data: { "functionid": "retrievereleasenotes", "libraryfunction": "axios" },
    }).then(async (resp) => {
        return resp.data;
    }).catch(async (error) => { });
    if (response.success) {
        return new Promise(resolve =>
            resolve({ data: response.storedReleaseNotes })
        )
    }
}

export const updateReleaseNotesAPI = async (newReleaseNote) => {
    let success = { 'success': false };
    try {
        let response = await axios({
            method: 'POST',
            //url: server_address + ':' + ports["master_server"] + '/',
            url: node_server_address,
            timeout: 5000,
            data: { "functionid": "changereleasenotes", "newReleaseNote": newReleaseNote, "libraryfunction": "axios" }
        })
        if (response?.data || response?.success) {
            success = { 'success': true };
        }
    } catch (error) {
        console.log("FAILURE of updateReleaseNotes")
        console.log(error);
    }
    return success;
}